import styled from "styled-components";

export const TableFooter = styled.div`
    display: flex;
  flex-direction: row;
  justify-content: space-between;
  div {
    margin-top: 1rem;
  }
`